export const es_translations = {
    "Sites": "Sitios",
    "Language": "Idioma",
    "Conditions": "Condiciones",
    "Grids": "Cuadrículas",
    "Sensors": "Sensores",
    "Alerts": "Alertas",
    "Analysis": "Análisis",
    "Live Data": "Datos Actualidad",
    "Grid": "Cuadrícula",
    "Pen": "Jaula",
    "Weather Station": "Estación Meteorológica",
    "Tension Gauge": "Indicador de Tensión",
    "Depth Meter": "Medidor de Profundidad",
    "Tilt Meter": "Medidor de Inclinación",
    "O2 Sensor": "Sensor de Oxigeno",
    "Top": "Parte Superior",
    "Bottom": "Fondo",
    "Ocean": "Oceano",
    "Equipment": "Equipo",
    "Weather": "Clima",
    "Livestock": "Ganado",
    "Fish": "Pescado",
    "Current" : "Corriente",
    "Meters": "Metros",
    "at" : "a",
    "Waves": "Las Olas",
    "Wave Height": "Altura de Las Olas",
    "Current Direction" : "Dirección del Corriente",
    "Current Speed" : "Velocidad del Corriente",
    "Current Direction at 10 Meters" : "Dirección del Corriente a 10 Metros",
    "Current Speed at 10 Meters" : "Velocidad del Corriente a 10 Metros",
    "Current Direction at 30 Meters" : "Dirección del Corriente a 30 Metros",
    "Current Speed at 30 Meters" : "Velocidad del Corriente a 30 Metros",
    "Significant Wave Height" : "Altura de las Olas Significativo",
    "Maximum Wave Height": "Altura de las Olas Máximo",
    "Large Wave Height": "Altura de las Olas Grande",
    "Mean Wave Period" : "Período Promedio de Olas",
    "Average": "Promedio",
    "Water Temperature": "Temperatura de Agua",
    "Air Temperature": "Temperatura de Aire",
    "Wind Speed": "Velocidad del Viento",
    "Wind Direction" : "Dirección del Viento",
    "Barometric Pressure": "Presión Barométrica",
    "Harness Tension": "Tensión del Arnés",
    "Pen Water Temperature": "Temperatura de Agua Jaula",
    "Pen Depth": "Profundidad de la Jaula",
    "Pen Tilt": "Inclinación de la Jaula",
    "Feed Duration": "Duración de la Alimento",
    "Feed Amount": "Cantidad de Alimento",
    "Parasite Count": "Recuento de Parásitos",
    "Mortality Count": "Recuento de Mortalidad",
    "Battery Power": "Energía de la Batería",
    "Surface Water Temperature": "Temperatura del Agua Superficial",
    "Floor Water Temperature" : "Temperatura del Agua Fondo",
    "Surface Wind": "Viento Superficial",
    "Currents at 10 Meters" : "Corriente a 10 Metros",
    "Currents at 20 Meters" : "Corriente a 20 Metros",
    "Currents at 30 Meters" : "Corriente a 30 Metros",
    "Dissolved Oxygen" : "Oxígeno Disuelto",
    "Surface Dissolved Oxygen" : "Oxígeno Disuelto Superficial",
    "Currents and Waves" : "Corriente y Las Olas",
    "Surface": "Superficie",
    "Floor" : "Fondo",
    "Device": "Dispositivo",
    "Serial No.": "Número de Serie",
    "Location": "Ubicación",
    "Updated": "Actualizado",
    "Power": "Energía",
    "Severity": "Gravedad",
    "Time": "Tiempo",
    "Message": "Mensaje",
    "Source": "El Origen",
    "Timeframe": "Periodo de Tiempo",
    "Time Series": "Series de Tiempo",
    "Data": "Datos",
    "Options": "Opciones",
    "Series": "Serie",
    "Interval": "Intervalo",
    "Calculation": "Cálculo",
    "Metric": "Métrico",
    "From Date": "De la Fecha",
    "To Date": "A la Fecha",
    "Logout": "Salir",
    "Login": "Acceder",
    "Welcome to": "Bienvenido a",
    "Unit": "Unidad",
    "Sensor": "Sensor",
    "Value": "Valor",
    "Timestamp": "Tiempo",
    "CRITICAL": "CRÍTICO",
    "WARNING": "ADVERTENCIA",
    "Minimum": "Mínimo",
    "Maximum": "Máximo",
    "Last": "Último",
    "Year": "Año",
    "Month": "Mes",
    "Week": "Semana",
    "Day": "Día",
    "Hour": "Hora",
    "Minute": "Minuto",
    "Second": "Segundo",
    "Normal": "Normal",
    "Warning": "Advertencia",
    "Alert": "Alerta",
    "Today": "Hoy",
    "Yesterday": "Ayer",
    "Past 24 Hours": "Las Últimas 24 Horas",
    "Past 7 Days": "Las Últimas 7 Dias",
    "Past 30 Days": "Las Últimas 30 Dias",
    "Past 60 Days": "Las Últimas 60 Dias",
    "Past 90 Days": "Las Últimas 90 Dias",
    "Past 120 Days": "Las Últimas 120 Dias",
    "Past 180 Days": "Las Últimas 180 Dias",
    "Past Year": "Año Pasado",
    "Date Range": "Rango de Fechas",
    "Days Back": "Días Atrás",
    "From": "De",
    "To": "A",
    "To view alerts, click the Display button after selecting your options.": "Para ver las alertas, haga clic en el botón Mostrar después de seleccionar sus opciones.",
    "Chart is limited to 1000 data points. To export all results, click the Download button.": "El gráfico está limitado a 1000 puntos de datos. Para exportar todos los resultados, haga clic en el botón Descargar.",
    "To view a report, click the Display button after selecting your options.": "Para ver un informe, haga clic en el botón Mostrar luego de seleccionar sus opciones.",
    "Export": "Exportar",
    "Back": "Espalda",
    "by": "por",
    "Speed": "Velocidad",
    "Direction": "Dirección",
    "Height": "Altura",
    "Temperature": "Temperatura",
    "Frequency": "Frecuencia",
    "Solution": "Solución",
    "Percent": "Por ciento",
    "Pressure": "Presión",
    "Tension": "Tensión",
    "Weight": "Peso",
    "Quantity": "Cantidad",
    "Age": "Años",
    "Level": "Nivel",
    "Humidity": "Humedad",
    "Tilt": "Inclinación",
    "Amount": "Cantidad",
    "Depth": "Profundidad",
    "Duration": "Duración",
    "Charge": "Cargar",
    "Bearing": "Dirección",
    "Select":"Escoger",
    "Clear": "Limpiar"
}